import { createContext, useContext, useMemo, useState } from "react";
import { TRANSLATIONS } from "./translations";

const LanguageContext = createContext(null);

const DATE_LOCALES = { en: "en-IN", kn: "kn-IN", sa: "hi-IN" };

export const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "kn", label: "ಕನ್ನಡ", short: "ಕ" },
  { code: "sa", label: "संस्कृतम्", short: "सं" },
];

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("matha_lang");
    return ["en", "kn", "sa"].includes(saved) ? saved : "kn";
  });

  const value = useMemo(() => {
    const setLang = (l) => {
      localStorage.setItem("matha_lang", l);
      setLangState(l);
    };
    const t = TRANSLATIONS[lang];
    const lv = (obj, field) => {
      if (!obj) return "";
      if (lang === "en") return obj[field] || "";
      return obj[`${field}_${lang}`] || obj[field] || "";
    };
    const fmtDate = (iso, opts = { day: "2-digit", month: "long", year: "numeric" }) => {
      try {
        return new Date(iso).toLocaleDateString(DATE_LOCALES[lang], opts);
      } catch {
        return iso;
      }
    };
    return { lang, setLang, t, lv, fmtDate };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}
